import { Pipe, PipeTransform } from '@angular/core';
import { ContextService } from '@maximizer/core/shared/data-access';
import { capitalize } from '@maximizer/shared/util';
import { TranslatePipe } from '@ngx-translate/core';

@Pipe({
  name: 'resourceOrTranslate',
  pure: false,
})
export class ResourceOrTranslatePipe
  extends TranslatePipe
  implements PipeTransform
{
  constructor(private readonly context: ContextService) {
    super();
  }

  override transform(
    key?: string,
    translateKey?: string,
    defaultText?: string,
  ): string {
    if (key) {
      if (key.indexOf('.') > -1) {
        translateKey = key;
        key = this.getResourceKey(key);
      }

      return this.getResourceOrDefault(
        key,
        this.getTranslationOrDefault(translateKey, defaultText),
      );
    }

    return this.getTranslationOrDefault(translateKey, defaultText);
  }

  private getResourceKey(key: string): string {
    const paths = key.split('.');
    return paths.reduce((path, segment) => {
      return `${path}${capitalize(segment)}`;
    }, 'JSS_');
  }

  private getResourceOrDefault(key: string, defaultText?: string): string {
    const resource = this.context.resources?.[key];
    if (resource?.trim()) {
      return resource;
    }
    return defaultText ?? '';
  }

  private getTranslationOrDefault(key?: string, defaultText?: string): string {
    if (key) {
      return super.transform(key);
    }

    return defaultText ?? '';
  }
}
